module.exports = __webpack_public_path__ + "img/attack_leafs.b3db319d.png";